import React from "react";
import { v4 as uuid } from "uuid";
import ufc from "@tvg/api/ufc";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@tvg/design-system";
import { getAccountNumber } from "@urp/store-selectors";
import { Props } from "./types";
import { getUserFavoriteRunners } from "../../../../store/selectors";
import {
  addToast,
  removeToast,
  addUserFavoriteRunner
} from "../../../../store/actions";

const FollowHorse = ({ runnerBI }: Props) => {
  const dispatch = useDispatch();

  const accountNumber = useSelector(getAccountNumber);
  const userFavoriteRunners = useSelector(getUserFavoriteRunners);

  const handleOnClick = () => {
    ufc
      .addRunnerToStable(
        accountNumber,
        "runner",
        [runnerBI.entityRunnerId || ""],
        runnerBI.runnerDob || -1,
        runnerBI.runnerName,
        ["raceResults", "raceDay", "timeToRace"]
      )
      .then(() => {
        dispatch(addUserFavoriteRunner(runnerBI.runnerName));

        const toastId = uuid();

        dispatch(
          addToast({
            id: toastId,
            variant: "success",
            title: "Added to Stable",
            message: "",
            hasDismissButton: true,
            actionLink: undefined,
            qaLabel: "add-to-stable-toast",
            onHide: () => dispatch(removeToast(toastId)),
            onDismissPress: () => dispatch(removeToast(toastId))
          })
        );
      })
      .catch(() => {
        const toastId = uuid();

        dispatch(
          addToast({
            id: toastId,
            variant: "informational",
            title: "Not able to add to Stable",
            message: "",
            hasDismissButton: true,
            actionLink: undefined,
            qaLabel: "add-to-stable-toast",
            onHide: () => dispatch(removeToast(toastId)),
            onDismissPress: () => dispatch(removeToast(toastId))
          })
        );
      });
  };

  const followingHorse = userFavoriteRunners.includes(runnerBI.runnerName);

  return (
    <>
      <Button
        qaLabel="btn-add-runner-to-stable"
        variant="tertiary"
        icon="stable"
        iconPosition="start"
        isDisabled={followingHorse}
        onPress={handleOnClick}
      >
        {followingHorse ? "Following" : "Follow Horse"}
      </Button>
    </>
  );
};

export default FollowHorse;
